import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import locale_en from 'dayjs/locale/en'

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.locale(locale_en)

const _dict = [
  'Pacific/Pago_Pago', 'Pacific/Honolulu', 'America/Anchorage',
  'America/Los_Angeles', 'America/Denver', 'America/Chicago',
  'America/New_York', 'America/Antigua', 'America/Buenos_Aires',
  'Atlantic/South_Georgia', 'Atlantic/Azores', 'Europe/London',
  'Europe/Paris', 'Europe/Athens', 'Europe/Moscow', 'Asia/Dubai',
  'Asia/Karachi', 'Asia/Dhaka', 'Asia/Bangkok', 'Asia/Shanghai',
  'Asia/Tokyo', 'Australia/Brisbane', 'Pacific/Guadalcanal',
  'Pacific/Nauru', 'Pacific/Tongatapu', 'Pacific/Kiritimati'
]
const l = _dict.length

export function _getUTCOffset(index = 0) {
  const i = Math.max(0, Math.min(l, index))
  const city = _dict[i]
  // const city = 'Asia/Tokyo' // dev
  // console.error(`i: ${i}, l: ${l}, city: ${city}`)
  const cityTime = dayjs().tz(city)
  const offset = cityTime.utcOffset() // 单位是分钟
  const th = (offset / 60)
  const hour = ~~th
  // console.error(`i: ${i}, l: ${l}, city: ${city}, offset: ${offset}, 结果utc${hour}, 实际上的偏移量(小时): ${th}`)
  return hour
}
